export var EmbedType;
(function (EmbedType) {
    EmbedType["DIAGRAM"] = "diagram";
    EmbedType["COMPONENT"] = "component";
})(EmbedType || (EmbedType = {}));
